/** @jsx jsx */
import React from 'react';
import { css, jsx, SerializedStyles } from '@emotion/core';
import { textFontSize, utilityColor, textColor } from 'components/styles';

const styles = {
  title: css({
    padding: '16px 15px',
    color: textColor.main,
    lineHeight: '30px',
    height: '30px',
    fontSize:'18px',
    fontfamily: 'Noto Sans',
    position: 'sticky', 
    top:'65px',
    background: utilityColor.white,
    // background: '#FAFBFC',
    zIndex: 2,

  }),
  note: css({
    fontSize: textFontSize.sm,
    marginLeft: '4px',
  }),
};

const FormTitle: React.FC<{
  title: string;
  note?: string;
  noteColor?: string;
  bold?: boolean;
  customStyle?: SerializedStyles;
}> = ({ title, note, noteColor = utilityColor.error, bold= true, customStyle }) => (
  <div css={[styles.title, { fontWeight: bold ? "bold" : "normal"}, customStyle]}>
    {title}
    {note && <span css={css(styles.note, { color: noteColor })}>{note}</span>}
  </div>
);

export default FormTitle;
